module.exports = __webpack_public_path__ + "./docs/img/icon-spanish.546447bc3bdd467d00b521b20b0a78c9.svg";